import { useTranslation } from "react-i18next";
import { TrendDownIcon, WarningIcon } from "@phosphor-icons/react";
import { Pills } from 'barte-design-system'

import { formatPercentage } from "@shared/helpers";
import { EPendencyRateCode } from "@payfac/types";

import { CarouselCardRow } from "./components";

import {
  PENDENCY_CODE_PILL_STATE,
  PENDENCY_CODE_VALUE_SUB_KEY,
} from "./carousel-card.constants";

import type { CarouselCardProps } from "./carousel-card.type";
import styles from "./carousel-card.module.css";

export const CarouselCard = ({ item, transitionState }: CarouselCardProps) => {
  const { t } = useTranslation();

  const isDefaultRate = item.code === EPendencyRateCode.DEFAULT_RATE;
  const pillState = PENDENCY_CODE_PILL_STATE[item.code];
  const pillIcon = isDefaultRate ? WarningIcon : TrendDownIcon;
  const valueSubKey = PENDENCY_CODE_VALUE_SUB_KEY[item.code];

  return (
    <div className={styles.card} data-state={transitionState ?? "idle"}>
      <div className={styles.header}>
        <span className={styles["header-index"]}>
          {t("payfac.pagePendenciesCarouselPendency")}{" "}
          <strong>#{String(item.id).padStart(4, "0")}</strong>
        </span>

        <Pills
          label={t(`enums.PENDENCY_CODE_${String(item.code).toUpperCase()}`)}
          icon={pillIcon}
          variant="light"
          state={pillState}
        />
      </div>

      <div className={styles.rows}>

        <div className={styles.value}>
          <span className={styles["value-sub"]}>
            {t(valueSubKey)}
          </span>

          <span className={styles["value-number"]}>
            {formatPercentage(item.currentValue)}
          </span>
        </div>

        <CarouselCardRow
          label={t("payfac.pagePendenciesShowMethod")}
          value={t(`enums.TAX_TYPE_${String(item.taxType).toUpperCase()}`)}
          strong
        />
        {item.installment != null && (
          <CarouselCardRow
            label={t("payfac.pagePendenciesShowInstallment")}
            value={t("payfac.pagePendenciesShowInstallmentValue", { number: item.installment })}
          />
        )}
        {item.brand && (
          <CarouselCardRow
            label={t("payfac.pagePendenciesShowBrand")}
            value={t(`enums.BRAND_${String(item.brand).toUpperCase()}`)}
          />
        )}
        {item.captureType && (
          <CarouselCardRow
            label={t("payfac.pagePendenciesShowCapture")}
            value={t(`enums.CAPTURE_${String(item.captureType).toUpperCase()}`)}
          />
        )}
      </div>
    </div>
  );
};
